import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { handleErrors } from '../../actions/ErrorActions';
import { getFormsList } from '../../api/forms-list';
import EditorDashboard from '../../components/EditorDashboard';
import { RECENT_FORMS_QUANTITY } from '../../constants/FormsListConstants';
import { STANDALONE_DASHBOARD_TYPES } from '../../constants/StandaloneLayoutConstants';
import { FORM_EDITOR, FORMS_LIST } from '../../constants/Urls';
import { useTranslation } from '../../custom-hooks/useTranslation';
import { importForm as importFormAction } from '../../form-designer/actions/editor.actions';
import { modifyForms } from '../../utils/formsListUtils';
import NavigateLinkCell from '../FindPage/NavigateLinkCell';

const FormListPage = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const translateString = useTranslation();
  const title = translateString('Forms');
  const [isLoading, setIsLoading] = useState(false);
  const [items, setItems] = useState([]);

  useEffect(() => {
    document.title = 'Forms Editor';

    const loadForms = async () => {
      setIsLoading(true);
      const response = await getFormsList();
      if (!response.hasError) {
        const { formList } = response;
        setItems(modifyForms(formList));
      } else {
        dispatch(handleErrors(response.errors));
      }
      setIsLoading(false);
    };

    loadForms();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const navigateToItemEditor = useCallback(
    ({ id, formKey, entityType }) => {
      history.push({
        pathname: FORM_EDITOR,
        search: `?formKey=${formKey}&formId=${id}&entityType=${entityType}&standaloneLayout=true`,
      });
    },
    [history]
  );

  const redirectToFormEditor = () => {
    history.push({
      pathname: FORM_EDITOR,
      search: '?isImport=true&standaloneLayout=true',
    });
  };

  const importForm = useCallback(async (file) => {
    dispatch(importFormAction({ file, redirectToFormEditor }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <EditorDashboard
      dashboardTitle={title}
      dashboardLink={FORMS_LIST}
      itemName="Forms"
      itemTitle="Recently Modified Forms"
      navigateToItemEditor={navigateToItemEditor}
      itemQuantity={RECENT_FORMS_QUANTITY}
      customCell={NavigateLinkCell.forUrl(FORM_EDITOR)}
      isLoading={isLoading}
      items={items}
      entityName="OptionStore"
      initialSearchName="All Forms"
      dashboardType={STANDALONE_DASHBOARD_TYPES.FORMS}
      importFile={importForm}
    />
  );
};

export default FormListPage;
